import Vue from 'vue';

// https://github.com/ElementUI/theme-chalk

import {
  Alert,
  Avatar,
  Badge,
  Breadcrumb,
  BreadcrumbItem,
  Button,
  Card,
  Carousel,
  CarouselItem,
  Checkbox,
  CheckboxGroup,
  Col,
  Collapse,
  CollapseItem,
  Container,
  DatePicker,
  Dialog,
  Drawer,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Form,
  FormItem,
  Header,
  Image,
  Input,
  InputNumber,
  Link,
  Main,
  Menu,
  MenuItem,
  Message,
  MessageBox,
  Notification,
  Option,
  OptionGroup,
  Popconfirm,
  Popover,
  Progress,
  Radio,
  RadioButton,
  RadioGroup,
  Row,
  Select,
  Switch,
  TabPane,
  Table,
  TableColumn,
  Tabs,
  Tag,
  TimePicker,
  Timeline,
  TimelineItem,
  Steps,
  Step,
  Tooltip,
  Upload,
} from 'element-ui';

import locale from 'element-ui/lib/locale';
import lang from 'element-ui/lib/locale/lang/en';

import './element-theme-chalk/lib/index.css';
import './element-theme-chalk/lib/alert.css';
import './element-theme-chalk/lib/badge.css';
import './element-theme-chalk/lib/breadcrumb-item.css';
import './element-theme-chalk/lib/breadcrumb.css';
import './element-theme-chalk/lib/carousel-item.css';
import './element-theme-chalk/lib/carousel.css';
import './element-theme-chalk/lib/checkbox-group.css';
import './element-theme-chalk/lib/checkbox.css';
import './element-theme-chalk/lib/collapse-item.css';
import './element-theme-chalk/lib/collapse.css';
import './element-theme-chalk/lib/date-picker.css';
import './element-theme-chalk/lib/dialog.css';
import './element-theme-chalk/lib/dropdown-item.css';
import './element-theme-chalk/lib/dropdown-menu.css';
import './element-theme-chalk/lib/dropdown.css';
import './element-theme-chalk/lib/icon.css';
import './element-theme-chalk/lib/image.css';
import './element-theme-chalk/lib/message-box.css';
import './element-theme-chalk/lib/message.css';
import './element-theme-chalk/lib/notification.css';
import './element-theme-chalk/lib/popover.css';
import './element-theme-chalk/lib/progress.css';
import './element-theme-chalk/lib/radio-group.css';
import './element-theme-chalk/lib/radio.css';
import './element-theme-chalk/lib/select.css';
import './element-theme-chalk/lib/switch.css';
import './element-theme-chalk/lib/table-column.css';
import './element-theme-chalk/lib/table.css';
import './element-theme-chalk/lib/tag.css';
import './element-theme-chalk/lib/time-picker.css';
import './element-theme-chalk/lib/timeline-item.css';
import './element-theme-chalk/lib/timeline.css';
import './element-theme-chalk/lib/steps.css';
import './element-theme-chalk/lib/tooltip.css';
import './element-theme-chalk/lib/upload.css';

locale.use(lang);

Vue.component('Row', Row);
Vue.component('Col', Col);
Vue.component('Card', Card);
Vue.component('Link', Link);
Vue.component('container', Container);
Vue.component('Header', Header);
Vue.component('Main', Main);
Vue.component('Button', Button);
Vue.component('Drawer', Drawer);
Vue.component('Menu', Menu);
Vue.component('menu-item', MenuItem);
Vue.component('Avatar', Avatar);
Vue.component('Input', Input);
Vue.component('InputNumber', InputNumber);
Vue.component('Form', Form);
Vue.component('FormItem', FormItem);
Vue.component('ElTabs', Tabs);
Vue.component('Tab-pane', TabPane);

Vue.component('Alert', Alert);
Vue.component('Badge', Badge);
Vue.component('Breadcrumb', Breadcrumb);
Vue.component('BreadcrumbItem', BreadcrumbItem);
Vue.component('Carousel', Carousel);
Vue.component('CarouselItem', CarouselItem);

Vue.component('Tooltip', Tooltip);
Vue.component('Popover', Popover);
Vue.component('Checkbox', Checkbox);
Vue.component('CheckboxGroup', CheckboxGroup);
Vue.component('Collapse', Collapse);
Vue.component('CollapseItem', CollapseItem);
Vue.component('DatePicker', DatePicker);
Vue.component('Dialog', Dialog);
Vue.component('Dropdown', Dropdown);
Vue.component('DropdownMenu', DropdownMenu);
Vue.component('DropdownItem', DropdownItem);
Vue.component('Message', Message);
Vue.component('MessageBox', MessageBox);
Vue.component('Notification', Notification);
Vue.component('Option', Option);
Vue.component('OptionGroup', OptionGroup);
Vue.component('Popover', Popover);
Vue.component('Progress', Progress);
Vue.component('Radio', Radio);
Vue.component('RadioGroup', RadioGroup);
Vue.component('RadioButton', RadioButton);
Vue.component('Select', Select);
Vue.component('SwitchBtn', Switch);
Vue.component('Table', Table);
Vue.component('TableColumn', TableColumn);
Vue.component('Tag', Tag);
Vue.component('Timeline', Timeline);
Vue.component('TimelineItem', TimelineItem);
Vue.component('ElSteps', Steps);
Vue.component('ElStep', Step);
Vue.component('TimePicker', TimePicker);
Vue.component('Tooltip', Tooltip);
Vue.component('Upload', Upload);
Vue.component('Popconfirm', Popconfirm);
Vue.component('ElImage', Image);
// Vue.use(Table);
// Vue.use(TableColumn);

let duration = 6000;

Vue.prototype.$PromptConfirm = function $confirm(message = 'Default message', title = 'Default title', defaultOptions) {
  const options = {};
  options.confirmButtonText = defaultOptions.confirmButtonText || 'Ok';
  options.cancelButtonText = defaultOptions.cancelButtonText || 'Cancel';
  options.closeOnClickModal = defaultOptions.closeOnClickModal || false;
  options.customClass = defaultOptions.customClass || '';
  return MessageBox.confirm(message, title, options);
};

Vue.prototype.$successMessage = function $message(data) {
  const h = this.$createElement;
  return Message({
    type: 'success',
    duration,
    message: h('div', null, [
      h('h3', null, data.header || 'Success'),
      h('span', data.message),
    ]),
    showClose: true,
    customClass: 'msgblock',
  });
};

Vue.prototype.$fixedInfoMessage = function $message(data) {
  const h = this.$createElement;
  return Message({
    type: 'info',
    duration: 0,
    message: h('div', null, [
      h('h3', null, data.header || 'Info'),
      h('span', data.message),
    ]),
    showClose: false,
    customClass: 'msgblock',
  });
};

Vue.prototype.$errorMessage = function $message(data) {
  const h = this.$createElement;
  return Message({
    type: 'error',
    duration,
    message: h('div', null, [
      h('h3', null, data.header || 'Error'),
      h('span', data.message),
    ]),
    showClose: true,
    customClass: 'msgblock',
  });
};

Vue.prototype.$warningMessage = function $message(data) {
  const h = this.$createElement;
  return Message({
    type: 'warning',
    duration,
    message: h('div', null, [
      h('h3', null, data.header || 'Warning'),
      h('span', data.message),
    ]),
    showClose: true,
    customClass: 'msgblock',
  });
};

Vue.prototype.$infoMessage = function $message(data) {
  const h = this.$createElement;
  return Message({
    type: 'info',
    duration,
    message: h('div', null, [
      h('h3', null, data.header || 'Info'),
      h('span', data.message),
    ]),
    showClose: true,
    customClass: 'msgblock',
  });
};

Vue.prototype.$success = function $notify({ message }) {
  return Notification({
    type: 'success', duration, message, showClose: true, customClass: 'success', dangerouslyUseHTMLString: true,
  });
};

Vue.prototype.$error = function $notify({ message, notAutoClosable = false }) {
  if (notAutoClosable) {
    duration = 0;
  }
  return Notification({
    type: 'error', duration, message, showClose: true, customClass: 'error', dangerouslyUseHTMLString: true,
  });
};

Vue.prototype.$info = function $notify({ message }) {
  return Notification({
    type: 'info', message, duration, showClose: true, customClass: 'success', dangerouslyUseHTMLString: true,
  });
};
